import { useParams } from "react-router-dom";
import { useExamDetail, useExamQuestionStatusGet } from "../../react-query/queries";
import { useAuth } from "../../utils/Auth/AuthProvider";
import { useState } from "react";
import ExamQuestionsInitial from "./ExamQuestionsInitial";
import AddQuestionsManual from './AddQuestionsManual'
import ExtractQuestionsFromFile from './ExtractQuestionsFromFile'
import ExtractQuestionsFromJSON from './ExtractQuestionsFromJSON'
import { Dispatch, SetStateAction } from 'react'

    // Simple in-file type for building questions manually


const ExamQuestionAddCard = ({
    examId: propExamId,
    onProceedToMeta,
    onRegisterExtractFn,
    onQuestionsExtracted,
    isExtracting,
    setIsExtracting,
}: {
    examId?: string | undefined
    onProceedToMeta?: (qs: any[]) => void
    onRegisterExtractFn?: (fn: () => void) => void
    onQuestionsExtracted?: () => void
    isExtracting: boolean
    setIsExtracting: Dispatch<SetStateAction<boolean>>
}) => {
    const { token } = useAuth();
    const params = useParams();
    const routeExamId = params.examId
    const examId = propExamId ?? routeExamId
    const [mode, setMode] = useState<'extract' | 'manual' | 'json'>('extract');
    const [questionsState, setQuestionsState] = useState<any[]>([]);

    const { status: examStatus, data: examData, error: examError } = useExamDetail(token, examId)
    const { data: qStatData } = useExamQuestionStatusGet(token, examId)

    // fileRef removed; extraction handled by ExtractQuestionsFromFile component


    return (
        <>
            <div className="col-span-1"></div>
            <div className="col-span-8 rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
                <div className="max-w-full overflow-x-auto">
                    <div className="mb-6 flex items-center justify-between">
                        <h4 className="text-xl font-semibold text-black dark:text-white">Adding Questions</h4>
                        <div className="text-sm text-gray-500">Use the tabs below to extract from a file or add questions manually.</div>
                    </div>
                    {
                        examError != null ? <p>Error</p>
                            : examStatus == 'success' ?
                                <div className="flex flex-row justify-center gap-5">
                                    <div className="basis-1/2">
                                                <div className="space-y-3">
                                                    <div className="flex items-center gap-3">
                                                        <div className="text-sm text-gray-600 w-28">Exam Name:</div>
                                                        <div className="flex-1 bg-gray text-gray-800 font-medium px-3 py-1 rounded dark:bg-gray dark:text-gray-300">{(examData as any)?.exam?.name || ''}</div>
                                                    </div>

                                                    <div className="flex items-center gap-3">
                                                        <div className="text-sm text-gray-600 w-28">Subject:</div>
                                                        <div className="flex-1 bg-gray text-gray-800 font-medium px-3 py-1 rounded dark:bg-gray dark:text-gray-300">{(examData as any)?.exam?.subject || ''}</div>
                                                    </div>

                                                    <div className="flex items-center gap-3">
                                                        <div className="text-sm text-gray-600 w-28">Grade:</div>
                                                        <div className="flex-1 bg-gray text-gray-800 font-medium px-3 py-1 rounded dark:bg-gray dark:text-gray-300">{(examData as any)?.exam?.school_grade_name || (examData as any)?.exam?.grade || ''}</div>
                                                    </div>
                                                </div>
                                    </div>
                                    <div className="basis-1/2">
                                        <div className="space-y-3">
                                            <div className="flex items-center gap-3">
                                                <div className="text-sm text-gray-600 w-28">Time Given:</div>
                                                <div className="flex-1 bg-gray text-gray-800 font-medium px-3 py-1 rounded dark:bg-gray dark:text-gray-300">{((examData as any)?.exam?.time ?? (examData as any)?.exam?.time_given) ? `${(examData as any).exam.time ?? (examData as any).exam.time_given} minutes` : 'Not assigned'}</div>
                                            </div>

                                            <div className="flex items-center gap-3">
                                                <div className="text-sm text-gray-600 w-28">Status:</div>
                                                {
                                                    (() => {
                                                        const statusVal = (qStatData as any)?.stat || (examData as any)?.exam?.status || '';
                                                        if (statusVal === 'Active') {
                                                            return <div className="bg-green-200 text-green-800 font-medium px-3 py-1 rounded">{statusVal}</div>
                                                        }
                                                        return <div className="bg-blue-200 text-blue-900 font-medium px-3 py-1 rounded">{statusVal || 'Draft'}</div>
                                                    })()
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : <p>Loading ...</p>
                    }

                    <hr className="h-px my-5 bg-slate-200 border-0 dark:bg-gray-700" />

                    {
                        questionsState.length > 0 ?
                            <>
                                <div className="flex flex-row justify-center">
                                    <button type="button" onClick={() => { setQuestionsState([]); }} className="text-red-700 inline-flex items-center hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900">
                                        CHANGE/REMOVE ALL
                                    </button>
                                </div>
                                <h1>Bellow are Questions ready for review. If there is any problem with the question, you can fix it here.</h1>
                                <br /><br />
                                <ExamQuestionsInitial questions={questionsState} onProceedToMeta={onProceedToMeta} />
                            </>
                            :
                            <div>
                                            <div className="mb-4 border-b border-stroke">
                                                <nav className="-mb-px flex space-x-3" aria-label="Tabs">
                                                    <button onClick={() => setMode('extract')} className={`py-2 px-5 rounded-md ${mode === 'extract' ? 'bg-primary text-white font-semibold' : 'bg-transparent text-bodydark2 border border-transparent hover:bg-slate-50'}`}>Extract from file</button>
                                                    <button onClick={() => setMode('json')} className={`py-2 px-5 rounded-md ${mode === 'json' ? 'bg-primary text-white font-semibold' : 'bg-transparent text-bodydark2 border border-transparent hover:bg-slate-50'}`}>Extract from JSON</button>
                                                    <button onClick={() => setMode('manual')} className={`py-2 px-5 rounded-md ${mode === 'manual' ? 'bg-primary text-white font-semibold' : 'bg-transparent text-bodydark2 border border-transparent hover:bg-slate-50'}`}>Add manually</button>
                                                </nav>
                                            </div>

                                    {mode === 'extract' ? (
                                        <ExtractQuestionsFromFile
                                            onExtract={(paras) => {
                                                setQuestionsState(paras);
                                                if (onQuestionsExtracted) onQuestionsExtracted();
                                                if (setIsExtracting) setIsExtracting(false);
                                                if (onProceedToMeta) onProceedToMeta(paras); // Call onProceedToMeta here
                                            }}
                                            onRegisterExtractFn={onRegisterExtractFn}
                                            isExtracting={isExtracting}
                                            setIsExtracting={setIsExtracting}
                                        />
                                    ) : mode === 'json' ? (
                                        // Lazy-load the JSON extractor UI
                                        <>
                                            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                                            {/* @ts-ignore */}
                                            <ExtractQuestionsFromJSON onExtract={(paras: any[]) => {
                                                setQuestionsState(paras);
                                                if (onQuestionsExtracted) onQuestionsExtracted();
                                                if (setIsExtracting) setIsExtracting(false);
                                                if (onProceedToMeta) onProceedToMeta(paras);
                                            }} />
                                        </>
                                    ) : (
                                        <AddQuestionsManual onAdd={(q) => setQuestionsState((prev) => [...prev, q])} />
                                    )}
                            </div>
                    }

                    <br /><br />
                </div>
            </div >
            <div className="col-span-1"></div>
        </>
    )
}

export default ExamQuestionAddCard
